import config from '@/config'

export default {
  bytesToSize: function (bytes: number, decimals: number = 2) {
    if (bytes == 0) return '0 byte'
    const k = 1000 // or 1024 for binary
    const dm = decimals || 3
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  },

  clone: function (obj: any) {
    return JSON.parse(JSON.stringify(obj))
  },

  queryParams: function (location: any) {
    const params: any = {}
    const paramsRaw = location.search.replace('?', '').match(/([^&=]+)=?([^&]*)/g) || []
    for (const i in paramsRaw) {
      const parts = paramsRaw[i].split('=')
      if (parts[1] !== undefined) {
        params[parts[0]] = parts[1]
      }
    }
    return params
  },

  buildUrlWithQuery: function (url: string, params: any) {
    if (!url.startsWith('http') && !url.startsWith('https')) {
      url = config.backendUrl + url
    }
    return (
      (url.indexOf('?') !== -1 ? url.slice(0, url.indexOf('?')) : url) +
      '?' +
      this.toSearchQuery(params)
    )
  },

  toSearchQuery: function (params: any) {
    return Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join('&')
  },

  formatDateTime: function (input: string): string {
    const d = new Date(input)

    const time = d.toLocaleTimeString('en-GB', { hour12: false })

    const date = d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })

    return `${time} / ${date}`
  },

  formatDate: function (input: string): string {
    const d = new Date(input)
    return d
      .toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
      .toUpperCase()
      .replace(/,/g, '')
  },

  formatDateTimeShort(input: string): string {
    const d = new Date(input)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0') // +1 vì getMonth() đếm từ 0
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}/${month}/${day}`
  },

  formatDateTime2: function (input: string): string {
    const d = new Date(input)

    const h = String(d.getHours()).padStart(2, '0')
    const m = String(d.getMinutes()).padStart(2, '0')
    const s = String(d.getSeconds()).padStart(2, '0')

    const day = d.getDate()
    const month = d.getMonth() + 1
    const year = d.getFullYear()

    return `${h}:${m}:${s} ${day}/${month}/${year}`
  },

  getCategory(filePath: string): 'image' | 'model3d' | 'tiles' | 'zip' {
    const ext = filePath.split('.').pop()?.toLowerCase() || ''

    const imageExt = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'heic', 'svg', 'tif']
    const modelExt = ['obj', 'fbx', 'stl', 'gltf', 'glb', 'dae', '3ds', 'ply', 'blend', 'usdz']
    const zipExt = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz']

    if (imageExt.includes(ext)) return 'image'
    if (modelExt.includes(ext)) return 'model3d'
    if (zipExt.includes(ext)) return 'zip'
    return 'tiles'
  },

  randomHexColor() {
    return (
      '#' +
      Math.floor(Math.random() * 0xffffff)
        .toString(16)
        .padStart(6, '0')
    )
  },

  capitalizeWords(text: string): string {
    if (!text) {
      return ''
    }
    const processedText = text.replace(/_/g, ' ')
    const lowerCaseText = processedText.toLowerCase()
    const capitalized = lowerCaseText.replace(/\b\w/g, (char) => char.toUpperCase())
    return capitalized
  },
}
